<div class="app-logo--wrapper">
  <svg version="1.1"
       xmlns="http://www.w3.org/2000/svg"
       xmlns:xlink="http://www.w3.org/1999/xlink"
       x="0px"
       y="0px"
       viewBox="0 0 1867.5 304.4"
       style="enable-background:new 0 0 1867.5 304.4;"
       xml:space="preserve"
       class="app-logo">
<style type="text/css">
	.app-logo--dot-wrapper{fill:none;stroke:#FFFFFF;stroke-width:10;}
  .app-logo--you,.app-logo--dot{fill:#0775FE;}
  .app-logo--safer{fill:#FFFFFF;}
</style>
    <path class="app-logo--dot-wrapper" d="M909.1,70.9c-46.6,0-84.5,37.8-84.5,84.5s37.8,84.5,84.5,84.5h199.5c46.6,0,84.5-37.8,84.5-84.5
	s-37.8-84.5-84.5-84.5C1108.6,70.9,909.1,70.9,909.1,70.9z"/>
    <path class="app-logo--dot" d="M1104.1,209.6c29.9,0,54.2-24.2,54.2-54.2s-24.2-54.2-54.2-54.2s-54.2,24.2-54.2,54.2
	S1074.2,209.6,1104.1,209.6"/>
    <path class="app-logo--you" d="M1780.3,243.1c55.1,0,87.2-31.7,87.2-83V55.3h-50v103.2c0,28.5-12.5,43.3-36.5,43.3s-37.2-14.7-37.2-43.3V55.3
	h-50.7v104.8C1693.1,211.4,1725.5,243.1,1780.3,243.1 M1555.7,201.8c-30.1,0-52.6-22.8-52.6-54.1s22.4-54.5,52.6-54.5
	s52.2,22.8,52.2,54.5S1585.8,201.8,1555.7,201.8 M1555.7,243.1c59.6,0,103.5-40.4,103.5-95.5s-43.9-95.8-103.5-95.8
	s-103.5,40.4-103.5,95.8S1496.1,243.1,1555.7,243.1 M1367.6,67.2v74.7c0,31.7-16.7,46.5-39.7,46.5s-34.9-12.8-34.9-42V67.2h-50v86.5
	c0,53.5,30.4,77.6,73.7,77.6c19.9,0,37.8-6.7,50.9-19.9v5.8c0,31.1-14.4,46.8-48.1,46.8c-21.5,0-43.9-7.4-58.3-19.2l-19.9,35.9
	c19.9,15.7,50.6,23.7,82.4,23.7c60.2,0,93.9-29.5,93.9-93.6V67.2H1367.6L1367.6,67.2z"/>
    <path class="app-logo--safer" d="M718.4,103.8v-33h-21.8v168.6h22.8v-85.9c0-39.7,21.5-62.2,56.7-62.2c1.6,0,3.5,0.3,5.5,0.3V69.5
	C750.5,69.5,729,81.4,718.4,103.8 M569.4,89.1c31.1,0,53.2,20.8,58,48.4l-118.9,23.1c-0.3-2.2-0.3-4.5-0.3-7.1
	C508.2,115.4,533.5,89.1,569.4,89.1 M575.2,220.8c-31.4,0-55.1-16.7-63.5-43.9L650.2,150c-1.6-47.4-35.6-80.4-80.8-80.4
	c-48.4,0-83.3,35.6-83.3,85.6s36.2,85.9,88.8,85.9c26.6,0,49.7-9.6,64.7-27.6l-12.8-14.7C614.3,213.4,596,220.8,575.2,220.8
	 M453.1,19.2c9.6,0,18.6,2.9,25,8.3l7.7-17C477.5,3.5,464.6,0,452.1,0c-33,0-51,19.9-51,50v20.8H371V90h30.1v149.3h22.8V90.1h51.3
	V70.8h-51.9V51C423.3,30.1,433.6,19.2,453.1,19.2 M249,220.8c-35.9,0-62.8-26.3-62.8-65.7s26.9-65.7,62.8-65.7s62.5,26.3,62.5,65.7
	S284.5,220.8,249,220.8 M311.1,70.8v32.1c-14.1-21.8-37.1-33.3-64-33.3c-48.1,0-84,34.6-84,85.6s35.9,85.9,84,85.9
	c27.9,0,51.3-12.2,65-34.9v33.3h21.8V70.8H311.1z M68.6,241c43.9,0,69.5-18.9,69.5-48.1c0-64.7-109.3-30.4-109.3-75.9
	c0-16,13.5-27.9,43.9-27.9c17.3,0,34.9,4.2,49.7,14.4l9.9-18.3c-14.1-9.6-37.8-15.7-59.6-15.7C29.8,69.5,6.1,90,6.1,117.6
	c0,66.7,109.3,32,109.3,76c0,16.7-13.1,27.6-45.2,27.6c-23.7,0-46.5-8.3-59.9-18.9L0,220.1C13.8,232,40.7,241,68.6,241"/>
</svg>
</div>


